import apiFaqsByTerm from '@/api/get/faqsByTerm';
import { isArrayNotEmpty, isNumber } from '@/utils/Common/Booleans';
import { getTemplate, htmlToElements } from '@/utils/Common/CustomTemplating';

export default () => {
  const lazyCta = document.getElementById('js-faq-results-lazy-cta');
  if (!lazyCta) return;

  const listResults = document.getElementById('js-faq-results');
  const { term, total } = lazyCta.dataset;
  const lazyCurrent = document.getElementById('js-faq-results-lazy-current');

  const handlerLazy = () => {
    const template = document.getElementById('js-faq-result-template');
    const currentShowing = lazyCurrent.innerText;
    const successCB = data => {
      if (isArrayNotEmpty(data.results)) {
        Array.from(data.results).forEach(item => {
          const el = htmlToElements(getTemplate(template.innerHTML, item));
          listResults.appendChild(el);
        });
        const liResults = listResults.querySelectorAll('li').length;
        lazyCurrent.innerText = liResults.toString();
        if (parseInt(total, 10) === parseInt(liResults, 10)) {
          lazyCta.parentNode.removeChild(lazyCta);
        }
      }
    };
    const from = isNumber(currentShowing) ? parseInt(currentShowing, 10) : 0;
    apiFaqsByTerm({ term, from, successCB });
  };

  lazyCta.addEventListener('click', handlerLazy);
};
